import {gql} from '@apollo/client';
import {TOURNAMENT_FRAGMENT, CONDITIONS_FRAGMENT} from '../fragments';

export const CREATE_TOURNAMENT = gql`
  ${TOURNAMENT_FRAGMENT}
  ${CONDITIONS_FRAGMENT}
  mutation createTournament($input: TournamentInput!) {
    createTournament(input: $input) {
      ...TournamentBasicInfo
      startDate
      finishDate
      address {
        country
        state
        city
      }
      conditions {
        ...ConditionsFields
      }
      hasFinal
      inscriptions {
        user {
          uid
        }
        state
      }
      standing
    }
  }
`;

export const UPDATE_TOURNAMENT = gql`
  ${TOURNAMENT_FRAGMENT}
  mutation updateTournament($tournamentId: ID!, $input: TournamentInput!) {
    updateTournament(tournamentId: $tournamentId, input: $input) {
      ...TournamentBasicInfo
    }
  }
`;

export const DELETE_TOURNAMENT = gql`
  ${TOURNAMENT_FRAGMENT}
  mutation deleteTournament($tournamentId: ID!) {
    deleteTournament(tournamentId: $tournamentId) {
      ...TournamentBasicInfo
    }
  }
`;

export const START_TOURNAMENT = gql`
  ${TOURNAMENT_FRAGMENT}
  mutation startTournament($tournamentId: ID!) {
    startTournament(tournamentId: $tournamentId) {
      ...TournamentBasicInfo
    }
  }
`;

export const FINISH_TOURNAMENT = gql`
  ${TOURNAMENT_FRAGMENT}
  mutation finishTournament($tournamentId: ID!) {
    finishTournament(tournamentId: $tournamentId) {
      ...TournamentBasicInfo
    }
  }
`;

export const PRE_REGISTER = gql`
  ${TOURNAMENT_FRAGMENT}
  mutation preRegister($uid: ID!, $tournamentId: ID!) {
    preRegister(uid: $uid, tournamentId: $tournamentId) {
      ...TournamentBasicInfo
    }
  }
`;

export const ADD_USER_TO_TOURNAMENT = gql`
  ${TOURNAMENT_FRAGMENT}
  mutation addUserToTournament($uid: ID!, $tournamentId: ID!) {
    addUserToTournament(uid: $uid, tournamentId: $tournamentId) {
      ...TournamentBasicInfo
    }
  }
`;

export const REMOVE_USER_FROM_TOURNAMENT = gql`
  ${TOURNAMENT_FRAGMENT}
  mutation removeUserFromTournament($uid: ID!, $tournamentId: ID!) {
    removeUserFromTournament(uid: $uid, tournamentId: $tournamentId) {
      ...TournamentBasicInfo
    }
  }
`;
